'use client';

import { c as _c } from "react/compiler-runtime";
import { motion, useReducedMotion } from 'motion/react';
import { IconView360 } from '@/app/components/icons/photo-image/icon-view-360';
import { SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_LABELS } from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/constants';
import type { SpartanProductExteriorThreesixtyDragGuideProps } from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/viewer/drag-guide/types';
import { SPARTAN_PRODUCT_EXTERIOR_TRACKING } from '@/app/lcv/components/sections/spartan/products/exterior/tracking';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
const DRAG_GUIDE_EASING = [0.4, 0, 0.2, 1] as const;
export const SpartanProductExteriorThreesixtyDragGuide = t0 => {
  const $ = _c(24);
  const {
    isVisible,
    tone: t1
  } = t0;
  const tone = t1 === undefined ? "light" : t1;
  const shouldReduceMotion = useReducedMotion() ?? false;
  const textColor = tone === "dark" ? "#1D1D1D" : "#FFFFFF";
  const iconColor = tone === "dark" ? "#3B3B3B" : "#FFFFFF";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = createDataAttributes({
      test: SPARTAN_PRODUCT_EXTERIOR_TRACKING.threesixtyGuideWrapper
    });
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = isVisible ? 1 : 0;
  const t4 = shouldReduceMotion || isVisible ? 0 : 8;
  let t5;
  if ($[1] !== t3 || $[2] !== t4) {
    t5 = {
      opacity: t3,
      y: t4
    };
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = shouldReduceMotion ? 0.1 : isVisible ? 0.3 : 0.18;
  const t7 = isVisible ? shouldReduceMotion ? 0.1 : 0.18 : 0;
  let t8;
  if ($[4] !== t6 || $[5] !== t7) {
    t8 = {
      duration: t6,
      delay: t7,
      ease: DRAG_GUIDE_EASING
    };
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const t9 = isVisible ? "visible" : "hidden";
  let t10;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = createDataAttributes({
      test: SPARTAN_PRODUCT_EXTERIOR_TRACKING.threesixtyGuide
    });
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== iconColor) {
    t11 = {
      color: iconColor
    };
    $[8] = iconColor;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <IconView360 />;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  let t13;
  if ($[11] !== t11) {
    t13 = <div className="size-8 shrink-0 translate-x-0.5 md:translate-x-0 [&_svg]:block [&_svg]:size-full [&_svg]:fill-current" style={t11}>{t12}</div>;
    $[11] = t11;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  let t14;
  if ($[13] !== textColor) {
    t14 = {
      color: textColor
    };
    $[13] = textColor;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      __html: SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_LABELS.guide
    };
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== t14) {
    t16 = <p className="text-body-2 where-span:text-inline-wrap text-center whitespace-nowrap text-shadow-[#000926]/2 text-shadow-md" style={t14} dangerouslySetInnerHTML={t15} />;
    $[16] = t14;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] !== t13 || $[19] !== t16 || $[20] !== t5 || $[21] !== t8 || $[22] !== t9) {
    t17 = <div aria-hidden="true" className="pointer-events-none absolute bottom-full left-1/2 w-max -translate-x-1/2 py-2" {...t2}><motion.div initial={false} animate={t5} transition={t8} data-visual-state={t9} className="flex items-center justify-center gap-3" {...t10}>{t13}{t16}</motion.div></div>;
    $[18] = t13;
    $[19] = t16;
    $[20] = t5;
    $[21] = t8;
    $[22] = t9;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  return t17;
};